/**
 * Coordinate Validation Utilities
 */

/**
 * Validates a UTM E coordinate
 * 
 * @param {String} utmE - The UTM E coordinate to validate
 * @returns {Object} - Validation result with isValid and message properties
 */
export const validateUTME = (utmE) => {
  // If empty, it's valid (field is optional)
  if (!utmE || utmE.trim() === '') {
    return {
      isValid: true,
      message: ''
    };
  }
  
  // Check if it's a 6-digit number
  const regex = /^\d{6}$/;
  const isValid = regex.test(utmE);
  
  return {
    isValid,
    message: isValid ? '' : 'UTM E must be a 6-digit number'
  };
};

/**
 * Validates a UTM N coordinate
 * 
 * @param {String} utmN - The UTM N coordinate to validate
 * @returns {Object} - Validation result with isValid and message properties
 */
export const validateUTMN = (utmN) => {
  // If empty, it's valid (field is optional)
  if (!utmN || utmN.trim() === '') {
    return {
      isValid: true,
      message: ''
    };
  }
  
  // Check if it's a 7-digit number
  const regex = /^\d{7}$/;
  const isValid = regex.test(utmN);
  
  return {
    isValid,
    message: isValid ? '' : 'UTM N must be a 7-digit number'
  };
};

export default {
  validateUTME,
  validateUTMN
};